module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp12_3016.d8a79d17.png";